import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from 'src/app/config.service';

@Pipe({
    name: 'rootsUrlPipe'
})
export class RootsUrlPipe implements PipeTransform {

  constructor(
    private configService: ConfigService
  ) {

  }

  transform(value: string): string {

    let url = `${this.configService.mcHost}/missioncontrol/roots/contactcard?id=${value}`

    return url
  }

}
